// article
const Listarticle = () => import('@/views/contributor/article')
const Formarticle = () => import('@/views/news_management/news/form')
const Detailarticle = () => import('@/views/news_management/news/detail')

export default {
    path: 'contributor-article',
    redirect: '/contributor-article',
    component: {
        render(c) { return c('router-view') }
    },
    meta: {
        label: 'Article'
    },
    children: [{
            path: '/',
            name: 'contributor-article',
            component: Listarticle,
            meta: {
                auth: true,
                label: 'Contributor Article',
                permission: {
                    link: "contributor-article",
                    name: "Article",
                }
            }
        },
        {
            path: 'add',
            name: 'addarticle',
            component: Formarticle,
            meta: {
                auth: true,
                label: 'Add Article',
                permission: {
                    link: "contributor-article",
                    name: "Article",
                }
            }
        },
        {
            path: 'edit/:id',
            name: 'editarticle',
            component: Formarticle,
            meta: {
                auth: true,
                label: 'Edit Article',
                permission: {
                    link: "contributor-article",
                    name: "Article",
                },
            }
        },
        {
            path: ':id',
            name: 'detailarticle',
            component: Detailarticle,
            meta: {
                auth: true,
                label: 'Detail Article',
                permission: {
                    link: "contributor-article",
                    name: "Article",
                },
            }
        },
    ]
}